// When the embed script gives the iframe the full height of its content, the
// page around it scrolls and fixed elements of the iframe would sit somewhere
// on its long page. The script reports which part of the iframe is visible;
// the booking bar and dialogs use it through CSS variables and this module.

const VIEWPORT_MESSAGE = "rentalls-parent-viewport";

let current = null;
const listeners = new Set();

export const getEmbedViewport = () => current;

export const subscribeEmbedViewport = (listener) => {
  listeners.add(listener);

  return () => listeners.delete(listener);
};

export const applyEmbedViewport = (viewport, root = document.documentElement) => {
  root.classList.add("embedded-viewport");
  root.classList.toggle("embedded-viewport--hidden", viewport.height < 1);
  // The page shows the booking bar itself.
  root.classList.toggle("embedded-parent-bar", viewport.bar === true);
  root.style.setProperty("--embed-visible-top", `${viewport.top}px`);
  root.style.setProperty("--embed-visible-height", `${viewport.height}px`);
};

// Reads a viewport message of the parent page; anything else returns null.
export const readViewportMessage = (event, parent) => {
  const data = event?.data;
  if (event?.source !== parent || !data || data.type !== VIEWPORT_MESSAGE) {
    return null;
  }
  const top = Number(data.top);
  const height = Number(data.height);
  if (!Number.isFinite(top) || !Number.isFinite(height)) {
    return null;
  }

  return { top: Math.max(0, top), height: Math.max(0, height), bar: data.bar === true };
};

export const startEmbedViewport = (win = window) => {
  if (win.parent === win) {
    return () => {};
  }

  const onMessage = (event) => {
    const viewport = readViewportMessage(event, win.parent);
    if (!viewport) return;
    current = viewport;
    applyEmbedViewport(viewport, win.document.documentElement);
    listeners.forEach((listener) => listener(viewport));
  };
  win.addEventListener("message", onMessage);
  // The page answers with the visible part right away.
  win.parent.postMessage({ type: "rentalls-iframe-ready" }, "*");

  return () => win.removeEventListener("message", onMessage);
};

// A new page of the booking app starts at its top, also on the parent page.
export const requestParentScrollToTop = (win = window) => {
  if (win.parent !== win) {
    win.parent.postMessage({ type: "rentalls-iframe-scroll-to-top" }, "*");
  }
};

// For tests.
export const resetEmbedViewport = () => {
  current = null;
  listeners.clear();
};
